// 共通のスタイル定義
export const createKeymanListStyles = () => ({
  root: {
    width: '100%',
    background: '#FFFFFF',
  },

  titleContainer: {
    padding: '20px 0px 18px 0px',
    boxSizing: 'border-box',
    background: '#F4F6F9',
    color: '#5A5B62',
    fontSize: '13px',
    fontWeight: 'bold',
  },

  title: {
    boxSizing: 'border-box',
    width: '100%',
  },

  emptyContainer: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    fontSize: '14px',
  },

  section: {
    background: '#F4F6F9',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100%',
    padding: '10px 25px 30px 25px',
    boxSizing: 'border-box',
  },

  rowWrap: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  },

  row: {
    display: 'flex',
    borderTop: '1px solid #D8DBDF',
    alignItems: 'center',
    width: '264px',
    boxSizing: 'border-box',
    padding: '14px 0px',
  },

  isEnable: {
    cursor: 'pointer',
    '&:hover': {
      background: 'rgba(243, 247, 255, 1)',
    }
  },

  showAll: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'end',
    width: '100%',
    boxSizing: 'border-box',
    cursor: 'pointer',
    color: '#1A65FF',
    fontSize: '13px',
    paddingTop: '15px',
    '&:hover': {
      textDecoration: 'underline',
    }
  },

  logo: {
    height: '37px',
    width: '37px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: '20px',
  },

  logoImg: {
    maxWidth: '37px',
    maxHeight: '37px',
  },

  text: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    width: '100%',
    boxSizing: 'border-box',
    display: 'block',
  },

  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    position: 'relative',
    minWidth: 0,
  },
});



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/dialogs/ExecDetailItemDialog/sections/shared/KeymanListStyles.js